import { topRank } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

export default function TopRank() {
  return (
    <section id="rank" className="scroll-mt-24 bg-background-950">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="h-9 w-1.5 rounded-full bg-accent-500" />
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-background-400">FULL HOT LIST</p>
              <h2 className="font-heading mt-1 text-2xl font-black text-background-50 md:text-3xl">深扒热度总榜</h2>
            </div>
          </div>
          <span className="hidden text-sm text-background-400 lg:block">基于阅读、评论与转载量综合计算</span>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {topRank.map((r, i) => (
            <article key={r.name} className="group flex items-center gap-4 rounded-lg border border-background-700/60 bg-background-900 p-4 transition-colors hover:border-accent-500/60">
              <span className={"font-heading flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-xl font-black " + (i < 3 ? "bg-accent-500 text-foreground-950" : "bg-background-700/60 text-background-50")}>
                {r.score}
              </span>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-background-50">{r.name}</h3>
                  <span className={"flex h-5 w-5 items-center justify-center rounded text-[11px] font-bold " + (r.trend === "新" ? "bg-primary-500 text-foreground-50" : "bg-background-700/70 text-background-200")}>
                    {r.trend}
                  </span>
                </div>
                <p className="mt-1 line-clamp-1 text-sm text-background-300">{r.desc}</p>
              </div>
              <span className="font-heading text-xs font-bold text-background-500">TOP {i + 1}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}